/**
 * External dependencies
 */
import { createSelector } from 'reselect';
import { get, find, map, sortBy, reverse } from 'lodash';

/**
 * Internal dependencies
 */
import { getAllCoupons } from 'state/coupons/selectors';
import { getAllAddons } from 'state/addons/selectors';

export const getCurrentSupportId = (state) => get(state, ['currentSupport', 'id']);

export const getCurrentSupport = (state) => {
    const id = getCurrentSupportId(state);

    if (!id) {
        return null;
    }

    return get(state, ['subscriptions', 'items', id]);
};

export const getCurrentSupportDenormalized = (state) => {
    let currentSupport = getCurrentSupport(state);

    if (!currentSupport) {
        return null;
    }

    const coupons = getAllCoupons(state);
    const addons = getAllAddons(state);

    currentSupport = {
        ...currentSupport,
        coupons: reverse(sortBy(map(currentSupport.coupons, ({ coupon_id }) => find(coupons, { id: coupon_id })), ({ discount_percentage}) => {
            return discount_percentage;
        })),
    };

    const addonTotal = get(currentSupport, 'addons', []).reduce((total, addon) => {
        return total + addon.amount;
    }, 0);

    let realTotal = addonTotal + currentSupport.plan_amount;

    get(currentSupport, 'coupons', []).forEach(coupon => {
        let discount = realTotal * (coupon.discount_percentage / 100);
        realTotal = realTotal - discount;
    })

    return { ...currentSupport, estimateTotal: realTotal };
};

export const requestingCurrentSupport = (state) => get(state, ['currentSupport', 'requesting'], false);

export const errorRequestingCurrentSupport = (state) => get(state, ['currentSupport', 'error'], false);

export const getCurrentSupportPlanId = createSelector(
    getCurrentSupport,
    (currentSupport) => {
        return get(currentSupport, ['plan_id'], null);
    },
);

export const hasScheduledChanges = createSelector(
    getCurrentSupport,
    (currentSupport) => {
        return get(currentSupport, ['has_scheduled_changes'], false);
    },
);
